"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Table = _interopRequireDefault(require("../../preact-components/table/Table"));

var _Loader = require("./Loader");

var _EmptyTable = _interopRequireDefault(require("./EmptyTable"));

var _EmptyResults = require("./EmptyResults");

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 25;
var PAGINATION_STORAGE_KEY = 'customersTablePagination';

var InactiveCustomersTable = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InactiveCustomersTable, _Component);

  var _super = _createSuper(InactiveCustomersTable);

  function InactiveCustomersTable() {
    var _this;

    (0, _classCallCheck2.default)(this, InactiveCustomersTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      inactiveCustomers: [],
      sorting: {
        order: 'lastSeen',
        direction: 'desc'
      },
      isLoading: true,
      isPaginationSet: false,
      pagination: {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
        total: undefined
      },
      total: undefined
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPageChange", function (page) {
      var _this$state$paginatio;

      var pageSize = (_this$state$paginatio = _this.state.pagination.pageSize) !== null && _this$state$paginatio !== void 0 ? _this$state$paginatio : DEFAULT_PAGE_SIZE;

      _this.updatePagination(page, pageSize);

      _this.fetchInactiveCustomers();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPageSizeChange", function (pageSize) {
      _this.updatePagination(DEFAULT_PAGE, pageSize);

      _this.fetchInactiveCustomers();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePagination", function (page, pageSize) {
      var newPagination = _objectSpread({}, _this.state.pagination);

      newPagination.page = page;
      newPagination.pageSize = pageSize;

      _this.setState({
        pagination: newPagination
      });

      _this.saveSessionPagination(page, pageSize);
    });
    return _this;
  }

  (0, _createClass2.default)(InactiveCustomersTable, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.fetchInactiveCustomers();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "fetchInactiveCustomers",
    value: function () {
      var _fetchInactiveCustomers = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$state, sorting, pagination, res, updatedPagination;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _this$state = this.state, sorting = _this$state.sorting, pagination = _this$state.pagination;
                _context2.prev = 2;
                _context2.next = 5;
                return this.props.fetchData('/analyticsV2/fetchInactiveCustomers', sorting.order, sorting.direction, pagination.page, pagination.pageSize);

              case 5:
                res = _context2.sent;
                updatedPagination = _objectSpread({}, pagination);
                updatedPagination.total = res.data.total;
                this.setState({
                  inactiveCustomers: res.data.customers,
                  total: res.data.total,
                  isLoading: false,
                  pagination: updatedPagination
                });

              case 9:
                _context2.prev = 9;
                this.setState({
                  isLoading: false
                });
                return _context2.finish(9);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2,, 9, 12]]);
      }));

      function fetchInactiveCustomers() {
        return _fetchInactiveCustomers.apply(this, arguments);
      }

      return fetchInactiveCustomers;
    }()
  }, {
    key: "getModel",
    value: function getModel() {
      return [{
        header: 'Company',
        accessor: 'companyName',
        size: 's'
      }, {
        header: 'Last seen',
        accessor: 'lastSeen',
        size: 'xl',
        sorting: 'lastSeen'
      }];
    }
  }, {
    key: "saveSessionPagination",
    value: function saveSessionPagination(page, pageSize) {
      var item = window.sessionStorage.getItem(PAGINATION_STORAGE_KEY);
      var storage = item ? JSON.parse(item) : null;
      storage.pagination = {
        page: page,
        pageSize: pageSize
      };
      window.sessionStorage.setItem(PAGINATION_STORAGE_KEY, JSON.stringify(storage));
    }
  }, {
    key: "getPaginationOptions",
    value: function getPaginationOptions() {
      var pagination = this.state.pagination;

      if (pagination === undefined) {
        return undefined;
      }

      var total = pagination.total;

      if (total !== undefined && total > 25) {
        return {
          pagination: _objectSpread(_objectSpread({}, pagination), {}, {
            total: total
          }),
          onPageChange: this.onPageChange,
          onPageSizeChange: this.onPageSizeChange
        };
      }

      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isSalesforceIntegrationEnabled = this.props.isSalesforceIntegrationEnabled;
      var _this$state2 = this.state,
          inactiveCustomers = _this$state2.inactiveCustomers,
          sorting = _this$state2.sorting,
          isLoading = _this$state2.isLoading;
      var table = (0, _preact.h)("div", {
        className: "data-not-tracked-text"
      }, "There\u2019s no data yet");

      if (isSalesforceIntegrationEnabled) {
        if (isLoading) {
          table = (0, _preact.h)(_EmptyTable.default, {
            model: this.getModel()
          }, (0, _preact.h)(_Loader.Loader, {
            parentCustomClass: "dashboard-table-loader"
          }));
        } else if (inactiveCustomers.length > 0) {
          table = (0, _preact.h)(_Table.default, {
            model: this.getModel(),
            rows: inactiveCustomers,
            classes: ['inactive_customers__table'],
            onSortChange: function onSortChange(attr) {
              var newSorting;

              if (sorting && sorting.order === attr) {
                newSorting = {
                  order: attr,
                  direction: sorting.direction === 'asc' ? 'desc' : 'asc'
                };
              } else {
                newSorting = {
                  order: attr,
                  direction: 'asc'
                };
              }

              inactiveCustomers.sort(function (a, b) {
                if (a[attr] > b[attr]) return 1 * (newSorting.direction === 'asc' ? 1 : -1);
                if (a[attr] < b[attr]) return -1 * (newSorting.direction === 'asc' ? 1 : -1);
                return 0;
              });

              _this2.setState({
                sorting: newSorting
              });

              _this2.fetchInactiveCustomers();
            },
            "data-element-name": "Inactive customers table sort button",
            "data-track-type": "click",
            sort: sorting,
            withPagination: this.getPaginationOptions()
          });
        } else {
          table = (0, _preact.h)(_EmptyTable.default, {
            model: this.getModel()
          }, ' ', (0, _preact.h)(_EmptyResults.EmptyResults, null));
        }
      }

      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('dashboard-table-wrapper', {
          'no-data': !isSalesforceIntegrationEnabled
        })
      }, table);
    }
  }]);
  return InactiveCustomersTable;
}(_preact.Component);

var _default = InactiveCustomersTable;
exports.default = _default;